import { dom } from '@omegagrid/core';
import rp, { AppComponent, Application, ParsedComponentId } from '@reporting/rp-app-host';
import { Sidebar, IOContainer } from './components';
import { } from './adapters';
import { Thread } from '@reporting/rp-types/etl';

const createMainSidebar = (app: Application, componentId: ParsedComponentId) => {
	const sidebar = dom.createElement<Sidebar>('rp-io-sidebar');
	return sidebar;
}

const createContainer = async (app: Application, componentId: ParsedComponentId) => {
	const id = parseInt(componentId.ids[1]);
	const thread = await rp.ms('etl').get<Thread>(`threads/${id}`, {
		fields: ['id_thread', 'description', 'type'],
		scope: 1
	});
	if (!thread) return null;

	const component = dom.createElement<IOContainer>('rp-io-container');
	component.thread = thread;
	return component;	
}

export const componentFactories = new Map<string, (app: Application, componentId: ParsedComponentId) => AppComponent|Promise<AppComponent>>([
	['io', createMainSidebar],
	['container', createContainer],
]);

